function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var t = /*#__PURE__*/function () {
  function t(_t) {
    _classCallCheck(this, t);

    var e = _t.url,
        s = _t.token;
    this._url = e, this._token = s, this._mode = 1, this._seed = 1, this._queue = [], this.data = {}, this.api = {}, this._events = {};
  }

  _createClass(t, [{
    key: "headers",
    value: function headers() {
      return {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Remote-Token": this._token
      };
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function (_t2, e) {
      var s = {
        credentials: "include",
        headers: this.headers()
      };
      return e && (s.method = "POST", s.body = e), fetch(_t2, s).then(function (_t3) {
        return _t3.json();
      });
    })
  }, {
    key: "load",
    value: function load(_t4) {
      var _this = this;

      return _t4 && (this._url = _t4), this.fetch(this._url).then(function (_t5) {
        return _this.parse(_t5);
      });
    }
  }, {
    key: "parse",
    value: function parse(_t6) {
      var e = _t6.key,
          s = _t6.websocket;
      e && (this._token = _t6.key);

      for (var _e in _t6.data) {
        this.data[_e] = _t6.data[_e];
      }

      for (var _e2 in _t6.api) {
        var _s = this.api[_e2] = {},
            i = _t6.api[_e2];

        for (var _t29 in i) {
          _s[_t29] = this._wrapper(_e2 + "." + _t29);
        }
      }

      return s && this.connect(), this;
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this2 = this;

      var _t8 = this._socket;
      _t8 && (this._socket = null, _t8.onclose = function () {}, _t8.close()), this._mode = 2, this._socket = function (t, e, s, i) {
        var n = e;
        "/" === n[0] && (n = document.location.protocol + "//" + document.location.host + e);
        n = n.replace(/^http(s|):/, "ws$1:");
        var o = -1 != n.indexOf("?") ? "&" : "?";
        n = "".concat(n).concat(o, "token=").concat(s, "&ws=1");
        var r = new WebSocket(n);
        return r.onclose = function () {
          return setTimeout(function () {
            return t.connect();
          }, 2e3);
        }, r.onmessage = function (e) {
          var s = JSON.parse(e.data);

          switch (s.action) {
            case "result":
              t.result(s.body, []);
              break;

            case "event":
              t.fire(s.body.name, s.body.value);
              break;

            case "start":
              i();
              break;

            default:
              t.onError(s.data);
          }
        }, r;
      }(this, this._url, this._token, function () {
        return _this2._mode = 3, _this2._send(), _this2._resubscribe(), _this2;
      });
    }
  }, {
    key: "_wrapper",
    value: function _wrapper(_t9) {
      return function () {
        var _this3 = this;

        var e = [].slice.call(arguments);
        var s = null;
        var i = new Promise(function (i, n) {
          s = {
            data: {
              id: _this3._uid(),
              name: _t9,
              args: e
            },
            status: 1,
            resolve: i,
            reject: n
          }, _this3._queue.push(s);
        });
        return this.onCall(s, i), 3 === this._mode ? this._send(s) : setTimeout(function () {
          return _this3._send();
        }, 1), i;
      }.bind(this);
    }
  }, {
    key: "_uid",
    value: function _uid() {
      return (this._seed++).toString();
    }
  }, {
    key: "_send",
    value: function _send(_t10) {
      var _this4 = this;

      if (2 == this._mode) return void setTimeout(function () {
        return _this4._send();
      }, 100);
      var e = _t10 ? [_t10] : this._queue.filter(function (_t11) {
        return 1 === _t11.status;
      });
      if (!e.length) return;
      var s = e.map(function (_t12) {
        return _t12.status = 2, _t12.data;
      });
      3 !== this._mode ? this.fetch(this._url, JSON.stringify(s))["catch"](function (_t13) {
        return _this4.onError(_t13);
      }).then(function (_t14) {
        return _this4.result(_t14, s);
      }) : this._socket.send(JSON.stringify({
        action: "call",
        body: s
      }));
    }
  }, {
    key: "result",
    value: function result(_t15, e) {
      var s = {};
      if (_t15) for (var _e3 = 0; _e3 < _t15.length; _e3++) {
        s[_t15[_e3].id] = _t15[_e3];
      } else for (var _t30 = 0; _t30 < e.length; _t30++) {
        s[e[_t30].id] = {
          id: e[_t30].id,
          error: "Network Error",
          data: null
        };
      }

      for (var _t31 = this._queue.length - 1; _t31 >= 0; _t31--) {
        var _e4 = this._queue[_t31],
            i = s[_e4.data.id];
        i && (this.onResponse(_e4, i), i.error ? _e4.reject(i.error) : _e4.resolve(i.data), this._queue.splice(_t31, 1));
      }
    }
  }, {
    key: "on",
    value: function on(_t18, e) {
      var s = this._uid();

      var i = this._events[_t18];
      var n = !!i;
      return n || (i = this._events[_t18] = []), i.push({
        id: s,
        handler: e
      }), n || 3 != this._mode || this._socket.send(JSON.stringify({
        action: "subscribe",
        name: _t18
      })), {
        name: _t18,
        id: s
      };
    }
  }, {
    key: "_resubscribe",
    value: function _resubscribe() {
      if (3 == this._mode) for (var _t32 in this._events) {
        this._socket.send(JSON.stringify({
          action: "subscribe",
          name: _t32
        }));
      }
    }
  }, {
    key: "detach",
    value: function detach(_t20) {
      if (!_t20) {
        if (3 == this._mode) for (var _t33 in this._events) {
          this._socket.send(JSON.stringify({
            action: "unsubscribe",
            key: _t33
          }));
        }
        return void (this._events = {});
      }

      var e = _t20.id,
          s = _t20.name,
          i = this._events[s];

      if (i) {
        var _t34 = i.filter(function (_t23) {
          return _t23.id != e;
        });

        _t34.length ? this._events[s] = _t34 : (delete this._events[s], 3 == this._mode && this._socket.send(JSON.stringify({
          action: "unsubscribe",
          name: s
        })));
      }
    }
  }, {
    key: "fire",
    value: function fire(_t24, e) {
      var s = this._events[_t24];
      if (s) for (var _t35 = 0; _t35 < s.length; _t35++) {
        s[_t35].handler(e);
      }
    }
  }, {
    key: "onError",
    value: function onError(_t26) {
      return null;
    }
  }, {
    key: "onCall",
    value: function onCall(_t27, e) {}
  }, {
    key: "onResponse",
    value: function onResponse(_t28, e) {}
  }]);

  return t;
}();

export { t as Client };